module.exports = __webpack_public_path__ + "images/ktm_small3626690ebddf7ff4c3d2eb888fa127fe.png";